import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=13832db2&scoped=true"
import script from "./tagList.vue?vue&type=script&lang=js"
export * from "./tagList.vue?vue&type=script&lang=js"
import style0 from "./tagList.vue?vue&type=style&index=0&id=13832db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13832db2",
  null
  
)

export default component.exports